import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './OrderDisclaimer.css';

const OrderDisclaimer = ({ specialHandlingInstructions }) => (
  <div className={styles.container}>
    <p>
      {specialHandlingInstructions} If you have any questions please contact{' '}
      <Link className={styles.link} to="/contact">
        Customer Service
      </Link>
    </p>
  </div>
);

OrderDisclaimer.propTypes = {
  specialHandlingInstructions: PropTypes.string,
};
export default OrderDisclaimer;



// WEBPACK FOOTER //
// ./src/containers/CartPage/OrderDisclaimer.jsx